export default function checkIsPropertyValueMissing(property: any, MetaType: any) {
  switch (property.template.type) {
    case MetaType.NUMBER:
      return !(property.value || property.value === 0) ? true : false
    case MetaType.SELECT_MULTI:
    case MetaType.SELECT_MULTI_USER:
    case MetaType.SELECT_MULTI_GROUP:
      return property.value?.length === 0 ? true : false
    default:
      return !property.value || property.value.toString().trim().length === 0 ? true : false
  }
}
